module.exports = __webpack_public_path__ + "static/media/logo-lado-bom-seguros.4733887a.svg";